var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C97AA",
  d: "M2 12.5v2a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C97AA",
  strokeLinejoin: "round",
  d: "M9 3v10m0 0-2.5-2.5M9 13l2.5-2.5"
})));
export { SvgIcDownload as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMTIuNTAwMlYxNC41MDAyQzIgMTUuNjA0OCAyLjg5NTQzIDE2LjUwMDIgNCAxNi41MDAySDE0QzE1LjEwNDYgMTYuNTAwMiAxNiAxNS42MDQ4IDE2IDE0LjUwMDJWMTIuNTAwMiIgc3Ryb2tlPSIjM0M5N0FBIi8+CjxwYXRoIGQ9Ik05IDMuMDAwMjRWMTMuMDAwMk05IDEzLjAwMDJMNi41IDEwLjUwMDJNOSAxMy4wMDAyTDExLjUgMTAuNTAwMiIgc3Ryb2tlPSIjM0M5N0FBIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";